import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";
import PageHeader from "../../components/PageHeader";
import AdmissionList from "./AdmissionList";
import AcademicCycleSelect from "../../components/common-input/AcademicCycle";

export default function Admissions() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-row justify-between  gap-5">
        <PageHeader title="ADMISSIONS LIST" />
        <div className="flex flex-col md:flex-row justify-end items-end ">
          <div className="flex gap-3">
            <AcademicCycleSelect
              name="class"
              value=""
              placeholder="Filter by Academic Cycle..."
              onChange={() => {}}
              selectClassName="border-none bg-white "
            />
            <CustomInput
              name="cycle"
              value=""
              type="date"
              placeholder="Select date range"
              onChange={() => {}}
              inputClassName="border-none bg-white"
            />
          </div>

          <CustomButton
            text="Add New"
            color="bg-primary-500"
            onClick={() => navigate("/admissions/add-new-admission")}
          />
        </div>
      </div>
      <AdmissionList />
    </div>
  );
}
